import React, { useEffect } from "react";
import BackgroundImage from '../../assets/backgroundLogin.jpg';
import { useState } from "react";
import { Icon } from 'react-icons-kit';
import { eyeOff } from 'react-icons-kit/feather/eyeOff';
import { eye } from 'react-icons-kit/feather/eye';
import { useNavigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import Swal from 'sweetalert2';

function Register() {
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(eyeOff);
  const [iconConfirm, setIconConfirm] = useState(eyeOff);
  const [typeConfirm, setTypeConfirm] = useState('password');
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPasword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phone, setPhone] = useState('');
  const navigate = useNavigate();
  let headers = new Headers();
  let url = "https://trototbe.azurewebsites.net/api/Users/Signup";
  headers.append('Content-Type', 'application/json');

  useEffect(() => {
    if (localStorage) {
      localStorage.removeItem("Token");
      localStorage.removeItem("Role");
      localStorage.removeItem("Id");
    }
  }, [])

  const togglePassword = async () => {
    if (type === 'password') {
      setIcon(eye);
      setType('text');
    } else {
      setIcon(eyeOff);
      setType('password');
    }
  };

  const toggleConfirmPassword = async () => {
    if (typeConfirm === 'password') {
      setIconConfirm(eye);
      setTypeConfirm('text');
    } else {
      setIconConfirm(eyeOff);
      setTypeConfirm('password');
    }
  };

  const handleNameChange = event => {
    setName(event.target.value);
  };

  const handleEmailChange = event => {
    setEmail(event.target.value);
  };

  const handlePasswordChange = event => {
    setPasword(event.target.value);
  };

  const handleConfirmPasswordChange = event => {
    setConfirmPassword(event.target.value);
  };

  const handlePhoneChange = event => {
    setPhone(event.target.value);
  };

  const fetchUserData = async (e) => {
    e.preventDefault();
    const res = await fetch(url, { mode: 'cors', method: 'POST', headers: headers, body: JSON.stringify({ "email": email, "password": password, "confirmPassword": confirmPassword, "fullName": name, "phoneNumber": phone }) });
    if (res.status === 200) {
      const data = await res.text();
      localStorage.setItem("Token", data);
      localStorage.setItem("Role", jwtDecode(data).Role);
      localStorage.setItem("Id", jwtDecode(data).UserId);
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Đăng ký thành công!',
        showConfirmButton: false,
        timer: 1500
      })
      if (jwtDecode(data).Role === 'User') {
        navigate('/home');
      }
    }else{
      const data = await res.text();
      Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: data
        })
    }
  };

  return (
    <div className="w-full h-screen relative flex justify-center items-center">
      <img className="w-full h-full" src={BackgroundImage} alt="/" />
      <div className="absolute w-full h-full top-0 left-0 bg-gray-900/30"></div>
      <div className="absolute h-5/6 w-2/5 flex flex-col justify-center items-center text-center text-white bg-white m-auto rounded-md shadow-2xl">
        <h1 className="text-black font-sans text-4xl font-semibold">Đăng kí tài khoản</h1>
        <form className="m-10" onSubmit={fetchUserData}>
          <div>
            <input className="bg-[#F1F1F1] p-3 w-full rounded-md font-sans text-base text-black focus:outline-0" type="text" placeholder="Họ và tên" required onChange={handleNameChange} value={name} />
            <input className="bg-[#F1F1F1] mt-3 p-3 w-full rounded-md font-sans text-base text-black focus:outline-0" type="email" placeholder="Email" required onChange={handleEmailChange} value={email} />
            <div className="relative">
              <input className="bg-[#F1F1F1] mt-3 p-3 w-full rounded-md font-sans text-base text-black focus:outline-0" type={type} placeholder="Mật khẩu" required onChange={handlePasswordChange} value={password} />
              <div className="absolute right-5 top-6 text-black">
                <span onClick={togglePassword}><Icon icon={icon} size={25} /></span>
              </div>
            </div>
            <div className="relative">
              <input className="bg-[#F1F1F1] mt-3 p-3 w-full rounded-md font-sans text-base text-black focus:outline-0" type={typeConfirm} placeholder="Xác nhận mật khẩu" required onChange={handleConfirmPasswordChange} value={confirmPassword} />
              <div className="absolute right-5 top-6 text-black">
                <span onClick={toggleConfirmPassword}><Icon icon={iconConfirm} size={25} /></span>
              </div>
            </div>
            <input className="bg-[#F1F1F1] mt-3 p-3 w-full rounded-md font-sans text-base text-black focus:outline-0" type="text" placeholder="Số điện thoại" required onChange={handlePhoneChange} value={phone} />
            <div>
              <button className="bg-[#6F977F] mt-5 p-2 w-full rounded-md text-black font-sans font-bold" type="submit" >Đăng kí</button>
            </div>
            <div className="text-black font-sans mt-5 italic">
              <p>Bạn đã có tài khoản? <a className="underline text-[#8B8B8B]" href="/login">Đăng nhập</a></p>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Register;